import { useMemo, memo } from "react";
import Chart from "react-apexcharts";
import "./chart.css";

function ChartBarGrouped({
  data,
  categoryKey,
  categorie,
  valueKey,
  percentageKey,
  titleX,
  titleY,
  isHorizontal = false,
  showPercentage = true,
}) {
  const { categories, series } = useMemo(() => {
    if (!data?.length) return { categories: [], series: [] };
    const cats = [...new Set(data.map((item) => item[categoryKey]))];
    const types = [...new Set(data.map((item) => item[categorie]))];
    const srs = types.map((type) => ({
      name: `${type}`,
      data: cats.map((cat) => {
        const item = data.find((d) => d[categoryKey] === cat && d[categorie] === type);
        return item ? (showPercentage ? item[percentageKey] : item[valueKey]).toFixed(1) : 0;
      }),
    }));
    return { categories: cats, series: srs };
  }, [data, categoryKey, categorie, showPercentage, percentageKey, valueKey]);

  const options = useMemo(
    () => ({
      chart: { type: "bar", stacked: false },
      plotOptions: { bar: { horizontal: isHorizontal } },
      dataLabels: {
        enabled: false,
      },
      xaxis: {
        categories,
        title: { text: titleX, style: { color: "var(--text-50)" } },
        labels: { style: { colors: "var(--text-50)" } },
      },
      yaxis: {
        title: { text: titleY, style: { color: "var(--text-50)" } },
        labels: {
          style: { colors: "var(--text-50)" },
          formatter: (val) => (showPercentage ? `${val.toFixed(1)}%` : val),
        },
      },
      tooltip: {
        y: { formatter: (val) => (showPercentage ? `${val.toFixed(1)}%` : val) },
      },
      legend: { labels: { colors: "var(--text-50)" } },
    }),
    [isHorizontal, showPercentage, categories, titleX, titleY]
  );

  return (
    <Chart options={options} series={series} type="bar" height="100%" width="100%" />
  );
}

export default memo(ChartBarGrouped);
